/** @module csi/image/ImageEditorStringRenderer */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/heading/String"
],function(declare,locale,String) {
	return declare(String, {
		/**
		 * Add tooltip text
		 * @override
		 */
		toTooltip: function(ctx, h, tooltip) {
			h.m_tooltip = locale.getNodeConfiguredName(ctx.getNode(), ctx.cache, ctx.locale);
			this.inherited(arguments);
		},
		
		/**
		 * Make links open in new tab on image editor 
		 * @override
		 */
		_toHtml: function(ctx, h, refNode, actionData, bSub) {
			ctx.bForceBrowse = true;
			ctx.fd = {linkTarget: "_blank"};
			return this.inherited(arguments);
		}
	});
});